export enum SuburbLookupValueStyle {
  SuburbOnly,
  SuburbAndPostcode,
}
